import { Modal, Text, Button, Image } from '@atoms/index';
import React from 'react';

function SucessMessageModal({ show, onClose }) {
    return (
        <Modal
            show={show}
            onClose={onClose}
            hideTitle={true}
            width="w-[328px] md:w-[396px]"
            label="Info"
            labelSize="text-lg md:text-xl"
            children={
                <div className="flex flex-col items-center h-full justify-between text-center">
                    <Image
                        className="h-8 mb-3"
                        src={'/images/rightTick.svg'}
                    />
                    <div className="w-full">
                        <Text
                            content="Message Successfully Sent"
                            className="h5-semibold text-primary-500"
                        />
                        <Text
                            content="Thanks! We will reach out to you shortly."
                            className="p4-regular"
                        />
                        <div className="pt-4 flex justify-center">
                            <Button
                                id="successMessageModalOkButton"
                                onClick={onClose}
                                buttonType="submit"
                                design="standard"
                                type="primary"
                                paddingClass="px-12 py-2.5"
                                wrapperclass='rounded-lg'
                                className="text-center"
                                children={
                                    <Text
                                        content={`Okay`}
                                        className="p3-semibold"
                                    />
                                }
                            />
                        </div>
                    </div>
                </div>
            }
        />
    );
}

export default SucessMessageModal;
